const getElementHeight = (element) => {
    if (!element) {
        return 0;
    }

    return element.offsetHeight || element.getBoundingClientRect?.().height || 0;
};

export const getSystemMessageHeight = (location) => {
    const wrapper = document.querySelector(`[data-testid="systemMessageDisplay.${location}"]`);
    const elements = wrapper
        ? [wrapper]
        : Array.from(document.querySelectorAll(`[data-testid^="systemMessage.${location}"]`));

    return elements.reduce((total, element) => total + getElementHeight(element), 0);
};

export const observeSystemMessageHeight = ({ location, onUpdate }) => {
    const updateHeight = () => {
        onUpdate(getSystemMessageHeight(location));
    };

    const scheduleUpdate = () => {
        requestAnimationFrame(updateHeight);
    };

    scheduleUpdate();

    if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', scheduleUpdate);
        return () => window.removeEventListener('resize', scheduleUpdate);
    }

    const wrapper = document.querySelector(`[data-testid="systemMessageDisplay.${location}"]`);
    const elements = wrapper
        ? [wrapper]
        : Array.from(document.querySelectorAll(`[data-testid^="systemMessage.${location}"]`));
    const observer = new ResizeObserver(scheduleUpdate);

    elements.forEach((element) => observer.observe(element));
    window.addEventListener('resize', scheduleUpdate);

    return () => {
        observer.disconnect();
        window.removeEventListener('resize', scheduleUpdate);
    };
};
